import { useSelector } from '@/libs/state'
import { replyingTo$ } from '../store'

// Reads the message the user is currently replying to from global UI state.
// Keeping this in a small hook lets the page and composer stay decoupled from
// the observable implementation.
const useReplyTarget = () => {
	const replyTo = useSelector(replyingTo$)
	const clearReply = () => replyingTo$.set(null)

	return { replyTo, clearReply }
}

export { useReplyTarget }
